<template>
   
    <div class="main_contain">
        <div class="container">

            <div class="title">
                <h5 class="font-active">Friendly At Your Service</h5>
            </div>

            <div class="">
                <swiper :modules="[SwiperAutoplay]"
                :autoplay="{
                delay: 2500,
                disableOnInteraction: false
                }"
                :spaceBetween="15"
                :loop="true"
                :breakpoints="{
                365: {
                    slidesPerView:3,
                    slidesPerGroup:1,
                    centeredSlides: true,
                    spaceBetween: 15,

                },  
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                    spaceBetween: 15,
                    autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                    },  
                },
                992: {
                    slidesPerView: 6,
                    slidesPerGroup: 1,
                    spaceBetween: 30,
                    autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                    },
                    
                },
                }" class="mySwiper">
                    <swiper-slide>
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/freeshipping.svg">
                                <p class="mb-0">Free <br> Shipping</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide v-if="$country.is_india">
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/fiveteenreturns.svg">
                                <p class="mb-0">15 Days <br> Returns</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide v-if="!$country.is_india">
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/thirtyreturns.svg">
                                <p class="mb-0">30 Days <br> Returns</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/assuredbuy.svg">
                                <p class="mb-0">Assured <br> BuyBack</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/exchange.svg">
                        <p class="mb-0">LifeTime <br> Exchange</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/warranty.svg">
                                <p class="mb-0">LifeTime <br> Warranty</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/engrave.svg">
                                <p class="mb-0">Free <br> Engraving</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/bespokejewel.svg">
                                <p class="mb-0">Bespoke <br> {{ $t('jewelry') }}</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/certs.svg">
                                <p class="mb-0">IGI & GIA
                                    <br>  Certification</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/ringresize.svg">
                        <p class="mb-0">Free RING
                             <br> Resizing</p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="slide_box">
                            <div class="box_retunr">
                                <img src="/assets/new-eng-landing/friendlyservice/virtualappt.svg">
                                <p class="mb-0">VIRTUAL <br> APPOINTMENTS</p>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>

</template>

<script setup>
 const { $country } = useNuxtApp()
</script>

<style scoped>
.mySwiper{
/* padding: 0 35px ; */
/* cursor: pointer; */
}
.box_retunr{
text-align: center
}

.main_contain {
background: linear-gradient(180deg, #668B84 0%, #405955 100%);
padding: 40px 20px;
/* border-radius: 8px; */
}

.title h5 {
color: #FFFFFF;
font-size: 32px;
text-align: center;
margin: 0 0 28px ;
}


.box svg {
width: 60px; 
height: 60px; 
}

.box_retunr p{
color: #FFFFFF;
font-size: 16px;
font-weight: 500;
letter-spacing: 2px;
text-align: center;
text-transform: uppercase;
margin-top: 16px;
}
@media (max-width: 992px) {
.box {
    width: 45%;
    
}
.box_retunr p{
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1.5px;
    text-align: center;
}
}
@media (max-width : 767px){

.main_contain {
    padding: 32px 12px;
    /* border-radius: 8px; */
}
.title h5 {
  font-size: 24px;
}
.box_retunr p{
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.5px;
    text-align: center;
}
}


</style>
